import { render, staticRenderFns } from "./document-info.vue?vue&type=template&id=7d2013ea&scoped=true&"
import script from "./document-info.vue?vue&type=script&lang=js&"
export * from "./document-info.vue?vue&type=script&lang=js&"
import style0 from "./document-info.vue?vue&type=style&index=0&id=7d2013ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2013ea",
  null
  
)

export default component.exports